export function isPersonalizedDiscountCoupon(couponCode?: string) {
  return Boolean(couponCode?.startsWith('P_'));
}
